import { LastSuccessfulSynchronizationItem } from './last-successful-synchronization';

export class SynchronizationCheckpoint {
  userEmail: string;
  startedAt: Date;
  updatedAt: Date;
  items: LastSuccessfulSynchronizationItem[];

  constructor(data: {
    userEmail: string;
    startedAt: Date;
    updatedAt: Date;
    items: LastSuccessfulSynchronizationItem[];
  }) {
    this.userEmail = data.userEmail;
    this.startedAt = data.startedAt;
    this.updatedAt = data.updatedAt;
    this.items = data.items;
  }
}
